import styled from 'styled-components';

export const LandingPageContainer = styled.div<{ $isMFE?: boolean }>`
  min-height: ${({ $isMFE }) => ($isMFE ? 'calc(100vh - 68px)' : '100vh')};
  display: flex;
  flex-direction: column;
`;

export const StyledPageContentHeader = styled.div`
  padding: 15px;
  display: flex;
  justify-content: space-between;
`;
